import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import DialogDirectives from './Dialog-directives';
import OutgoingDialogDirectives from './Outgoing-Dialog-Directive';
import $ from 'jquery';

class DialogDirectivesSubTabs extends Component {

  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/multilingual/dialog-directives";
      var path1 = window.origin + "/platform/projectmgmt/multilingual/dialog-directives/";
      if (currentPath === path || currentPath === path1) {
        $("#incoming-dialog-directive-tab").addClass('active');
      } else if (currentPath.includes('/dialog-directives/outgoing-dialog-directives')) {
        $("#outgoing-dialog-directive-tab").addClass('active');
      }
      $("#incoming-dialog-directive-tab,#outgoing-dialog-directive-tab")
        .on("click", function () {
          $("#incoming-dialog-directive-tab,#outgoing-dialog-directive-tab")
            .removeClass('active');
          localStorage.setItem("last-used-report-settings-sub-tab", $(this)[0].id);
          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />

          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="tab-class" style={{ marginLeft: '4px' }}>
              <ul className="nav nav-tabs border-bottom navCluster" >
                <Link className="nav-item" to="/projectmgmt/multilingual/dialog-directives" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="incoming-dialog-directive-tab" >
                   Customize Inputs
                  </li></Link>
                <Link className="nav-item" to="/projectmgmt/multilingual/dialog-directives/outgoing-dialog-directives" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="outgoing-dialog-directive-tab" >
                   Customize Outputs
                  </li></Link>




              </ul>
            </div>
          </div>
        </div>
        <Switch>

          <Route path="/projectmgmt/multilingual/dialog-directives/outgoing-dialog-directives" component={OutgoingDialogDirectives} ></Route>
          <Route path="/projectmgmt/multilingual/dialog-directives" component={DialogDirectives}></Route>


        </Switch>
      </div>

    );
  }
}
export default DialogDirectivesSubTabs;


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/Sub-tabs-Dialog-Directives.js